module.exports = __webpack_public_path__ + "assets/close.3465ef3f.svg";